import { z } from 'zod';

/**
 * How a response labels a person for display: the name shown as text and the avatar
 * initials. Mirrors the API's `PersonLabel` (api/src/repositories/person.ts), which is
 * where `initials` is computed from the AD name parts. The web renders `initials`
 * verbatim and must never derive initials itself.
 */
export const PersonLabelDto = z.object({
  displayName: z.string(),
  initials: z.string(),
});
export type PersonLabelDto = z.infer<typeof PersonLabelDto>;
